import { useSelector } from "react-redux";
import { selectIsLoggedIn } from "@landingClient/store/authSlice";
import { selectHeaderConfig } from "@landingClient/store/headerSlice";
import { useNavigate, useLocation } from "@tanstack/react-router";
import LoginButton from "./LoginButton";
import UserMenu from "./UserMenu";
import LogoImage from "../assets/textlessLogoTransparent.png";
import { Box } from "@mui/material";

const navLinks = [
  { name: "Product", href: "#features" },
  { name: "About", href: "#about" },
  { name: "Solutions", href: "#solutions" },
  { name: "FAQ", href: "/faq" },
];

export function PageHeader() {
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const { showLogo, animateLogo, statusActive } =
    useSelector(selectHeaderConfig);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <div
      className="relative backdrop-blur-sm border-b border-transparent data-[active=true]:border-border transition-colors duration-500 h-16 lg:h-24"
      data-active={statusActive || !showLogo}
    >
      {/* Mobile Header */}
      <div className="flex lg:hidden h-16 items-center justify-between px-4">
        {showLogo && (
          <button
            onClick={() => navigate({ to: "/" })}
            className="flex items-center gap-2 cursor-pointer hover:opacity-80"
            data-testid="button-home-mobile"
          >
            <img src={LogoImage} alt="SmartCMA Logo" className="w-13 h-13" />
            <span className="font-heading font-bold text-lg tracking-tight text-primary">
              SmartCMA
            </span>
          </button>
        )}
        <div>{isLoggedIn ? <UserMenu /> : <LoginButton />}</div>
      </div>

      {/* Desktop Header */}
      <div className="hidden lg:flex absolute inset-x-0 top-0 h-24 items-center justify-between px-8 z-60">
        {showLogo && (
          <button
            onClick={() => navigate({ to: "/" })}
            className={`pointer-events-auto flex items-center gap-2 transition-all duration-700 cursor-pointer hover:opacity-80 ${
              animateLogo
                ? "opacity-90 translate-x-0 delay-300"
                : "opacity-100 -translate-x-4"
            } ${!showLogo ? "hidden" : ""} ${
              animateLogo
                ? "animate-in fade-in slide-in-from-left-4 duration-700"
                : ""
            }`}
            data-testid="button-home"
          >
            <img src={LogoImage} alt="SmartCMA Logo" className="w-15 h-15" />

            <span className="font-heading font-bold text-xl tracking-tight text-primary">
              SmartCMA
            </span>
          </button>
        )}

        {pathname === "/" && (
          <Box
            component={"nav"}
            mx={"auto"}
            display={"flex"}
            gap={8}
            className="items-center"
          >
            {navLinks.map((link) => (
              <a
                key={link.name}
                onClick={() => navigate({ to: link.href })}
                style={{ cursor: "pointer" }}
                className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
              >
                {link.name}
              </a>
            ))}
          </Box>
        )}

        <div className="pointer-events-auto animate-in fade-in slide-in-from-right-4 duration-700">
          {isLoggedIn ? <UserMenu /> : <LoginButton />}
        </div>
      </div>
    </div>
  );
}
